import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CopyIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_10129_108190)'>
				<path
					d='M6 6.7L6 19.3C6 19.6866 6.39175 20 6.875 20L19.125 20C19.6082 20 20 19.6866 20 19.3L20 6.7C20 6.3134 19.6082 6 19.125 6L6.875 6C6.39175 6 6 6.3134 6 6.7Z'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M3 17L3 3.7C3 3.51435 3.09219 3.3363 3.25628 3.20503C3.42038 3.07375 3.64293 3 3.875 3L17 3'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_10129_108190'>
					<rect
						fill='white'
						height='24'
						transform='translate(0 24) rotate(-90)'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default CopyIcon;
